<template lang="pug" src="./Withdraws.pug">

</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { buildPayloadPagination } from '@/utils/utils.js'
import Purchases from './Purchases.vue'
import moment from 'moment-timezone'

export default{
  name: 'Withdraws',

  components: { Purchases },

  data: () => {
    // data local sem timezone (YYYY-MM-DD)
    const tz = new Date().getTimezoneOffset() * 60000
    const today = new Date(Date.now() - tz).toISOString().substr(0, 10)
    const start30 = new Date(Date.now() - tz - 30 * 86400000).toISOString().substr(0, 10)

    return {
      searchStatus: ['waiting_payment'],
      fab: false,
      hover: true,
      dialog: false,
      selectedId: '',
      selectedStatus: '',
      selected: [],
      dataTableLoading: false,
      expanded: [],
      select: false,
      singleExpand: false,
      search: '',
      pagination: { sortDesc: ['true'] },

      menu: false,
      datesRange: [start30, today], // 30 dias atrás até hoje

      fieldsToSearch: ['key', 'status'],
      detailsDialog: false,
      withdrawId: null,
      itemCopied: false,
      lineBreak: '\n'
    }
  },

  computed: {
    ...mapGetters(['dash', 'withdraws', 'totalWithdraws', 'withdrawsReport']),
    dateRangeText () {
      if (!this.datesRange || this.datesRange.length < 2) return ''
      const sorted = [...this.datesRange].sort((a, b) => new Date(a) - new Date(b))
      const human = sorted.map(d => moment(d).format('DD/MM/YYYY'))
      return human.join(' até ')
    },
    checkboxRule() {
      return [ this.searchStatus.length > 0 || 'Selecione pelo menos 1' ]
    },
    headers() {
      return [
        { text: 'Solicitado', value: 'createdAt' },
        { text: 'Pagar até', value: 'dueDate' },
        { text: 'Loja', value: 'storeName' },
        { text: 'Valor', value: 'value', sortable: false },
        { text: 'Status', value: 'status' },
        { text: 'Ações', value: 'actions' }
      ]
    },
    role() { return this.$store.state.auth.user.role }
  },

  methods: {
    ...mapActions(['getWithdraws', 'updateWithdraws', 'adminLogin', 'starkBankPay']),
    moment: () => moment(),

    applyDateRange() {
      this.$refs.menu.save(this.datesRange)
      this.pagination.page = 1
      this.doSearch()
    },

    informWithdraw(costumer){
      let firstName = costumer.event.userName.split(' ')[0]
      firstName = firstName.charAt(0).toUpperCase() + firstName.slice(1)
      let value = this.formatPrice(costumer.value)
      const text = `?text=Ol%C3%A1%20${firstName}!%20Tudo%20j%C3%B3ia%3F%0ASou%20a%20Marcella%20da%20iFraldas.%0ASeu%20resgate%20no%20valor%20de%20R%24${value}%20foi%20realizado%20com%20sucesso%20em%20${new Date(costumer.updatedAt).toLocaleDateString('pt-br')}.`
      let href = 'https://wa.me/55'+costumer.telefone.replace(/\D+/g, '')+text
      window.open(href, '_blank')
    },

    downloadNF(link){ window.open(link, '_blank') },
    starkBankReceipt(link){ window.open(link, '_blank') },

    async payWithStarkBank(eventId){ await this.starkBankPay({ eventId }) },
    loginAsPromoter(eventId){ this.adminLogin({ eventId }) },

    copyUserData(id){
      document.getElementById(`div${id}`).style.display = 'block'
      const copyText = document.getElementById(id)
      copyText.select()
      copyText.setSelectionRange(0, 99999)
      document.execCommand('copy')
      document.getElementById(`div${id}`).style.display = 'none'
      this.itemCopied = true
    },

    details(item){
      this.withdrawId = item._id
      this.detailsDialog = true
    },

    visitSite(slug){ window.open('https://cha.ifraldas.com.br/'+slug, '_blank') },

    goToEvent(id){
      const routeData = this.$router.resolve({ name: 'events-event', params: { activeTab: 2, eventId: id } })
      window.open(routeData.href, '_blank')
    },

    async getWithdrawsData(){
      let searchQuery = ''
      if (this.search.length > 0) searchQuery = `?key=${this.search}`
      await this.getWithdraws({ query: searchQuery })
    },

    getColor(item){
      if (item.status == 'paid') return '#20A39E'
      if (item.status == 'waiting_payment') return '#FFBA49'
      if (item.status == 'fraud') return '#FD6A6E'
      return '#CCC'
    },

    formatPrice(value) {
      if (value == undefined) value = 0
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },

    informFraud(id, status){
      this.dialog = true
      this.selectedId = id
      this.selectedStatus = status != 'fraud' ? 'fraud' : 'paid'
    },

    confirmChange(id, status){
      this.dialog = true
      this.selectedId = id
      this.selectedStatus = status
    },

    async checkOneWithdraw(){
      this.dialog = false
      const payload = { withdraws: [ { _id: this.selectedId, status: this.selectedStatus } ] }
      await this.updateWithdraws(payload)
      this.doSearch()
    },

    async checkWithdraws(){
      this.dialog = false
      const withdraws = this.selected.map(x => ({ _id: x._id, status: 'paid' }))
      const payload = { withdraws }
      await this.updateWithdraws(payload)
      this.doSearch()
    },

    async doSearch() {
      try {
        this.dataTableLoading = true
        await this.getWithdraws(
          buildPayloadPagination(this.pagination, this.buildSearch())
        )
        this.dataTableLoading = false
        this.dash.notifications.promoterWithdraws = 0
      } catch (error) {
        this.dataTableLoading = false
      }
    },

    newStatusSearch(){
      if (this.searchStatus.length > 0) {
        this.pagination.page = 1
        this.doSearch()
      }
    },

    buildSearch() {
      // monta o objeto de busca
      const search = this.search
        ? { status: this.searchStatus.join(','), searchTerm: this.search }
        : { status: this.searchStatus.join(',') }

      // período dentro de `search`
      if (this.datesRange && this.datesRange[0] && this.datesRange[1]) {
        search.start = `${this.datesRange[0]}T03:00:00.000Z`

        const endDate = new Date(`${this.datesRange[1]}T03:00:00.000Z`)
        const end = moment(endDate).add(86399, 'seconds').utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z'
        search.end = end
      }

      // IMPORTANTe: retornar um objeto com a key `search`
      return { search }
    }
  },

  mounted(){
    if (this.role == 'super') {
      this.select = true
      this.searchStatus = ['waiting_payment']
    }
    // busca inicial com o range padrão (últimos 30 dias)
    this.pagination.page = 1
    
  },

  watch: {
    pagination: {
      async handler() {
        try {
          this.dataTableLoading = true
          await this.getWithdraws(
            buildPayloadPagination(this.pagination, this.buildSearch())
          )
          this.dataTableLoading = false
          this.dash.notifications.promoterWithdraws = 0
        } catch (error) {
          this.dataTableLoading = false
        }
      },
      deep: true
    }
  }
}
</script>
<style>

  .influencer-emphasis {
    color: blue;
    font-weight: bold;
  }

    /* CSS corretivo: no Safari Mobile a tabela desconfigurava após expandir algum item */
    tr.v-data-table__expanded__content{
      box-shadow: none !important;
      background-color: #F9F9F9;
    }

    table tbody .v-data-table__mobile-table-row{
      display: block !important;
    }
    div.correctExpandableMobile tr.v-data-table__expanded__content{
      display: block !important;
      width: 100% !important;
    }
    div.correctExpandableMobile tr.v-data-table__expanded__content td{
      display: table;
      width: 100% !important;
    }

    .hiddenDiv{
      display: none;
    }

</style>
